import router from '@/router';
import { browserTracingIntegration, init, replayIntegration } from '@sentry/vue';
import Vue from 'vue';
import { version } from '../../package.json';

if (process.env.VUE_APP_SENTRY_URL) {
    init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_URL,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        integrations: [
            browserTracingIntegration({ router }),
            replayIntegration()
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        release: `szp-swr@${version}`
    });
}
